export function CardFooter({ children }) {
  return <footer className="card-footer">{children}</footer>;
}
